







































import Vue from 'vue';
import { isNil } from 'lodash';
import moment from 'moment';
import { SalesforceChatHelper } from '@/helpers';
import { getContentArea } from '@/contentful';
import { UserModel } from '@/@types/member';

interface Data {
  chatText: string;
}

export default Vue.extend({
  name: 'SalesforceChat',
  beforeMount() {
      getContentArea([
        'contact-us_text_chat',
      ]).then((data) => {
        // Set content;
        const contentArea = data[0];
        if (contentArea) {
          if (contentArea && contentArea.fields) {
            this.chatText =
              contentArea.fields.helpContent;
          }
        }
      });
  },
  created() {
    SalesforceChatHelper.initScript(this.$store.getters.user);
  },
  data(): Data {
    return {
      chatText: '',
    };
  },
  computed: {
    user(): UserModel {
      return this.$store.getters.user;
    },
    /*
     * @todo this we need a way to get what the business hours are and
     * what time is it at Further. Once you have these pieces of information
     * we should be able to figure out if we are within business hours.
     *
     * Additional questions to consider:
     *   - Do we need to consider holidays?
     *   - Do we need to consider weekends?
     */
    isWithinBusinessHours(): boolean {
      return true;
    },
    /*
     * Determine if the link should be shown. For testing you may need to return
     * true here if you don't have a user that has chat turned on.
     *
     * @docs https://jira.hellofurther.net/browse/PR-1598
     */
    showChatInfo(): boolean {
      if (
        isNil(this.user) &&
        isNil(this.user!.isChatEnabled)
      ) {
        return false;
      }

      return (
        this.user.isChatEnabled &&
        this.isWithinBusinessHours
      );
    },
    chatElement(): any {
      return document.querySelector(
        SalesforceChatHelper.CHAT_QUERY_SELECTOR,
      );
    },
  },
  methods: {
    clickChat(): void {
      if (isNil(this.chatElement)) {
        return;
      }

      this.chatElement.click();
    },
  },
});
